import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EMessageChannel } from './message';
import { EModel } from './model';
export let EMessageFailureMessageExternalSource;
(function (EMessageFailureMessageExternalSource) {
  EMessageFailureMessageExternalSource["Mandrill"] = "mandrill";
  EMessageFailureMessageExternalSource["Twilio"] = "twilio";
  EMessageFailureMessageExternalSource["Nexmo"] = "nexmo";
  EMessageFailureMessageExternalSource["Sendgrid"] = "sendgrid";
  EMessageFailureMessageExternalSource["Plivo"] = "plivo";
  EMessageFailureMessageExternalSource["Bandwidth"] = "bandwidth";
  EMessageFailureMessageExternalSource["RingCentral"] = "ringcentral";
  EMessageFailureMessageExternalSource["AWSSES"] = "awsses";
  EMessageFailureMessageExternalSource["Interfax"] = "interfax";
})(EMessageFailureMessageExternalSource || (EMessageFailureMessageExternalSource = {}));
export const fieldsMessageFailure = _extends({}, fieldsIBaseModelWithUser, {
  carrier: {
    type: 'Text'
  },
  channel: {
    type: 'Option',
    values: EMessageChannel
  },
  code: {
    type: 'Text'
  },
  externalId: {
    type: 'Object'
  },
  from: {
    type: 'Text'
  },
  hasLink: {
    type: 'Boolean'
  },
  message: {
    type: 'ID',
    ref: EModel.Message
  },
  patient: {
    type: 'ID',
    ref: EModel.User
  },
  reason: {
    type: 'Text'
  },
  ref: {
    type: 'Text'
  },
  refId: {
    type: 'Text'
  },
  text: {
    type: 'Text'
  },
  to: {
    type: 'Text'
  },
  type: {
    type: 'Text'
  }
});